module.exports = "\r\n.nav-tabs-wrapper{\r\n    font-size: 0.8rem !important;\r\n}\r\n"